import { LoadModelJson } from '../components/Layout-Components/Editor-Layout/Three-JS-Viewer/Controllers/Loader';
import {
    checkAndSetSetbackOverrideFlag,
    fetchSetbackInfo,
} from '../components/Layout-Components/Editor-Layout/Three-JS-Viewer/Controllers/PathwayControl';
import { captureDefaultLayoutSnapshotIfNeeded } from './layoutSnapshotCapture';
import { LoadingContext } from '../store/loadingMessageStore';
import { useViewerStore } from '../store/store';
import { logger } from '../services/loggingService';

/** Draw the 3D site model when it was deferred for dashboard-first entry. */
export async function runDeferredSiteModelLoadIfNeeded(): Promise<boolean> {
    const { deferredSiteModelLoad, sceneViewer, siteModelLoadInProgress } = useViewerStore.getState();
    if (!deferredSiteModelLoad || !sceneViewer || siteModelLoadInProgress) {
        return false;
    }

    useViewerStore.setState({ siteModelLoadInProgress: true });
    const loadingContext = new LoadingContext();
    loadingContext.setToBackground(true);
    loadingContext.setDefaultTitle('');

    try {
        const { designData, sfid, modelType } = deferredSiteModelLoad;
        loadingContext.setMessage({ message: 'Fetching Setback Info...' });
        await fetchSetbackInfo(sfid, sceneViewer);
        checkAndSetSetbackOverrideFlag(designData);

        loadingContext.setMessage({ message: 'Drawing Site...' });
        await LoadModelJson(sceneViewer, designData, modelType);
        captureDefaultLayoutSnapshotIfNeeded(sceneViewer);

        const wantLabels = useViewerStore.getState().isTreeLabelVisible;
        const currentVisible = sceneViewer.treeTagGroup?.visible;
        if (!!currentVisible !== wantLabels) {
            sceneViewer.toggleTreeLabel();
        }

        useViewerStore.setState({
            deferredSiteModelLoad: null,
            siteModelLoadPending: false,
        });
        return true;
    } catch (e) {
        logger.error('Deferred site model load failed', e);
        throw e;
    } finally {
        loadingContext.dispose();
        useViewerStore.setState({ siteModelLoadInProgress: false });
    }
}
